import { Mapper } from './mapper';
import { ProjectDto } from 'src/app/services/remote-data-service/dtos/project.dto';
import { Project } from 'src/app/entities/project/project';
import { ClientMapper } from './client.mapper';
import { UserMapper } from './user.mapper';

export class ProjectMapper extends Mapper<Project, ProjectDto> {
  /**
   * Client mapper.
   *
   * @protected
   * @memberof ProjectMapper
   */
  protected clientMapper;

  /**
   * User mapper.
   *
   * @protected
   * @memberof UserMapper.
   */
  protected userMapper;

  constructor() {
    super();
    this.clientMapper = new ClientMapper();
    this.userMapper = new UserMapper();
  }

  mapToEntity(dto: ProjectDto): Project {
    return new Project(
      dto.uuid,
      dto.title,
      dto.color,
      dto.permissions,
      dto.time_spent,
      new Date(dto.created),
      dto.active,
      dto.archived,
      this.clientMapper.mapToEntity(dto.client),
      dto.members ? this.userMapper.mapToEntities(dto.members) : undefined,
    );
  }
}
